import {Component, OnDestroy, OnInit} from '@angular/core';
import {Company, Token, UserDetails, UserSignInInfo, Subscription} from '../app.model';
import {AppService} from '../app.service';
import {CacheService} from '../cache.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';
import {environment} from '../../environments/environment';
import { environment as devEnvironment } from '../../environments/environment.development';
import { environment as testEnvironment } from '../../environments/environment.test';
import { environment as stagingEnvironment } from '../../environments/environment.staging';
import {NgForm} from '@angular/forms';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
//import

// import {MixpanelService} from '../services/mixpanel.service';
import { ReCaptchaV3Service } from "ng-recaptcha";
import { HubspotService } from '../services/hubspot/hubspot.service';
import { get, includes } from "lodash-es";
import { NS_Enums, oldPricingRoute, trialStarterConfigureDestination, trialStarterHeading } from "../shared/namespaces";
import { TrialPlanService } from '../services/trialplan/trialplan.service';
import { getRolesFromToken } from "src/app/shared/helpers/jwt.helper";
import { isLocalStorageAvailable } from "src/app/shared/helpers/helpers";
import { trackFreshsalesEvent } from "src/app/shared/helpers/faitracker-defense";
import { CookieConsentService, COOKIE_CONSENT_STATUS } from 'src/app/shared/services/cookie-consent.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Subscription as rxSubscription } from 'rxjs';

@Component({
  selector: 'app-login-register-new',
  templateUrl: './login-register-new.component.html',
  styleUrls: ['./login-register-new.component.scss']
})
export class LoginRegisterNewComponent implements OnInit, OnDestroy {
  TLD: boolean = true;
  invalidEmailCompany:  boolean = false;
  currentDomain: string;
  exampleBusinessEmail = 'name@company.com';
  invalidEmailHosts: string[] = ['gmail', 'yahoo', 'hotmail']
  userData: any;
  companies: Company[] = [];
  userSignUpInfo = new UserDetails();
  userSignInInfo: UserSignInInfo = new UserSignInInfo();
  verifyPassword: string;
  agreeTUP: boolean;
  rememberMe: boolean;
  showForgotPassword: boolean;
  userForgotPassword: UserSignInInfo = new UserSignInInfo();
  form: HTMLFormElement;
  showLoginBlock = false;
  showcheckemail=false;
  userId = 0;
  baseWord: string = this.appService.getBaseWord();
  uncommonBaseWord: string = this.appService.getUncommonBaseWord();
  signedUp = false;
  fieldTextType_P: boolean;
  fieldTextType_CP: boolean;
  strong_password=false;
  medium_password=false;
  weak_password=false;
  text_value="hide";
  under_signIn_process = false;
  trialSubscriptionPlan: Subscription = new Subscription();
  private appUrl = environment.apiUrl;
  under_creating_account = false
  userRole: string[] | string = [];
  counter: number = 0;
  carousel = [];
  showCookieCheckbox = true;
  routerEventsSubscription: rxSubscription;
  constructor(
    private snackBar: MatSnackBar,
    private appService: AppService,
    private trialPlanService: TrialPlanService,
    private cacheService: CacheService,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private afAuth: AngularFireAuth,
    private hubspotService: HubspotService,
    private recaptchaV3Service: ReCaptchaV3Service,
    public cookieConsentService: CookieConsentService
  ) {
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
      }
    });

    this.routerEventsSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.route),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      mergeMap(route => route.data)
    ).subscribe(data => {
      this.trackPageView(data.title);
    });
  }

  hasTLD(data:  any){
    // This fucntion is block the form from submitting if a top level domain (.com / .in)  is not present
    // This will also show invalid email error
    let [userName , domainName] = data.model.split('@');
    if(!domainName){
      this.TLD = false;
      return false;
    }

    let [host, TLD] = domainName.split('.');

    if(!TLD){
      this.TLD = false;
      return  false;
    }

    this.TLD  = true
    return true;
  }
  checkEmail(data: any){
    // This fucntion is to block the form from submitting if the company is one of  gmail / yahoo /  hotmail
    // !!! this function doesn't check the validity of the email.

    //bypass this validation in test and dev environment: Sumanth

    if(environment.stage !== testEnvironment.stage && environment.stage != devEnvironment.stage && environment.stage != stagingEnvironment.stage){
      let [userName , domainName] = data.model.split('@');
      for(let i = 0 ; i < this.invalidEmailHosts.length ; i++){
        let re = new RegExp(`.*@${this.invalidEmailHosts[i]}\..*`);
        if(re.test(data.model)){
          this.currentDomain = `@${domainName}`;
          this.invalidEmailCompany = true;
          return  false;
        }
      }
    }

    this.invalidEmailCompany = false;
    return  true;
  }

  ngOnInit() {
  //  window.location.reload(true)
    this.counter = 0;
    this.carousel = [
      {
        image_url: "../../assets/images/registration/ctmr_leadsphere.png",
        tstmnl:
          "Saras gave us seamless connection to Amazon’s APIs like SP-API, Amazon ads, Vendor Central and other APIs that are very hard to connect to. From Saras' consulting team, we got an automated set of dashboards for Sales, Advertising, P&L, Inventory, Products, etc., that is extremely relevant for our clients today.",
        logo_url: "../../assets/images/registration/testimonials_logo/leadsphere_logo.png",
        designation: "CEO, Leadsphere",
        name: "Sebastian Barrios",
      },
      {
        image_url: "../../assets/images/registration/ctmr_ptstory.png",
        tstmnl:
          "Saras helps us save 150-200 hours of time per month in manual reporting across Amazon Seller Central, Vendor Central and Ads. I would recommend Saras because of their grasp on data, eCommerce expertise, customizable solution and fair pricing with high quality consistency.",
        logo_url: "../../assets/images/registration/testimonials_logo/ptstory_logo.png",
        designation: "Cofounder, Pointstory",
        name: "Leszek Lekstan",
      },
      {
        image_url: "../../assets/images/registration/ctmr_upscalio.png",
        tstmnl:
          "We chose Saras and Daton for two reasons, one being the availability of data sources specifically Amazon, Flipkart, Pepperfry, Google Ads, Facebook Ads, Unicommerce etc. Secondly, for the expert data team which keeps interacting with us and helps us manage our data road map and data execution on a regular basis very well.",
        logo_url: "../../assets/images/registration/testimonials_logo/upscalio_logo.png",
        designation: "Head - Product, UpScalio",
        name: "Rohit Khatri",
      },
      {
        image_url: "../../assets/images/registration/ctmr_img.png",
        tstmnl:
          "Daton's Amazon connectors are something that in this moment of our business is very important and gives us the possibility to be on the market in a faster way.",
        logo_url: "../../assets/images/registration/testimonials_logo/TN_logo.png",
        designation: "CEO, Turnover",
        name: "Fabio Marin",
      },
    ];

    this.autoSlide();

    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    if (saras_auth_key) {
      this.userId = saras_auth_key.userId;
    }
    if (this.userId) {
      this.router.navigate(['/' + this.baseWord + '/datasources-listing']);
    }
    const emailQueryParam = this.route.snapshot.queryParamMap.get('email');
    if (emailQueryParam && !this.signedUp) {
      this.toggleSignIn();
      this.userSignUpInfo.email = emailQueryParam;
    } else if (emailQueryParam && this.signedUp) {
      this.userSignInInfo.email = emailQueryParam;
    }
  }

  changeSlideNext() {
    if (this.counter < this.carousel.length) this.counter += 1;
  }

  changeSlidePrev() {
    if (this.counter > 0) this.counter -= 1;
  }

  autoSlide() {
    setInterval(() => {
      if (this.counter == this.carousel.length - 1) {
        this.counter = 0;
      } else {
        this.counter += 1;
      }
    }, 10000);
  }

  toggleSignIn() {
    //this.buttonText = (this.buttonText === 'SIGN UP') ? 'SIGN IN' : 'SIGN UP';
    this.showLoginBlock = !this.showLoginBlock;
    if(isLocalStorageAvailable() && localStorage.getItem(COOKIE_CONSENT_STATUS)){
      this.showCookieCheckbox = false;
   }else{
    this.showCookieCheckbox = true;
   }
}

  signIn(isAfterSignUp = false) {
    this.under_signIn_process = true;
    this.recaptchaV3Service.execute('login').subscribe((token) => {
      this.userSignInInfo['recaptchaToken'] = token;
      this.afAuth.signInWithEmailAndPassword(this.userSignInInfo.email, this.userSignInInfo.password)
        .then((result) => {
          this.userData = result.user;
          return result.user.getIdTokenResult();
        })
        .then((idTokenResult) => {
          if (this.userData.emailVerified) {
            this.cacheService.putObject('isEmailVerified', true, true);
          } else {
            this.cacheService.putObject('isEmailVerified', false, true);
          }

            this.appService.verifyFirebaseToken(idTokenResult.token).then((saras_token) => {

              const token = new Token();
              const rolesFromToken = getRolesFromToken(saras_token.token)
              token.role = saras_token.role;
              token.token = saras_token.token;
              token.userId = saras_token.userId;
              this.userRole = rolesFromToken || saras_token.role;
              this.cacheService.putObject('saras_auth_key', token, true);
              this.cacheService.putObject('time-laps', new Date().getTime(), true)
              if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
                window['dataLayer'] = window['dataLayer'] || [];
                window['dataLayer'].push({'event': 'Sign-in', 'eventCategory': 'Sign-in', 'eventAction': 'Success'});

              }
              // this.closeModal();
              this.appService.getUserLoginEvent().next(true);
              this.routeBackFromLogin();
              this.routeToTopics();
              this.under_signIn_process = false;
              this.under_creating_account = false;
              if(isAfterSignUp){
                this.trialPlanService.doWhenNewUserSignUpReported(this.userSignUpInfo.email);
              }

            }).catch(error => {
              this.under_signIn_process = false;
              this.under_creating_account = false;
            } );

        })
        .catch((error) => {
          this.under_signIn_process = false;
          this.under_creating_account = false;
          const err: any = {};
          err['statusText'] = error.message;

          switch( error.code ) {
            case 'auth/user-not-found':
              err['status'] = 404;
              this.appService.openErrorDialog(err, false, 'Authentication error');
              break;
            case 'auth/wrong-password':
              err['status'] = 401;
              this.appService.openErrorDialog(err, false, 'Authentication error');
              break;
            default:
              break;
          }
          this.appService.getUserLoginEvent().next(false);
          // this.clearData();
        });
    }, (error) => {
      this.under_signIn_process = false;
      console.error('reCAPTCHA error', error);
    });
  }


  submitForgotPassword() {
    /* this.afAuth.auth.sendPasswordResetEmail(this.userForgotPassword.email).then(()=>{
          const dialogRef = this.dialog.open(CommonDialogComponent, {
            data: {
              title: 'Recover Password',
              content: 'A verification link has been sent',
              image: '../../assets/images/tickmark.jpg',
              buttons: [
                {
                  'title': 'OK',
                  'meta': '/' + this.uncommonBaseWord + '/login',
                  'type': 'no-change',
                  'class': 'confirm-dialog-later'
                }
              ]
            },
            disableClose: true
          });

          this.showForgotPassword = false;

        });
    */
   this.under_signIn_process = true
    this.appService.forgotPassword(this.userForgotPassword).then(() => {
      // this.openSuccessDailog('Alert!', 'A verification link has been sent');
      // require change add email in content
      /*const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: 'Recover Password',
          content: 'A verification link has been sent',
          image: '../../assets/images/tickmark.jpg',
          buttons: [
            {
              'title': 'OK',
              'meta': '/' + this.uncommonBaseWord + '/login',
              'type': 'no-change',
              'class': 'confirm-dialog-later'
            }
          ]
        },
        disableClose: true
      });*/
        this.under_signIn_process = false;
        this.under_creating_account = false;
        this.showcheckemail=true;
      //this.showForgotPassword = false;
      // this.dialogRef.close();
    });

  }


  /*sendVerifcation() {
    this.userData.sendEmailVerification();
    return auth.currentUser.sendEmailVerification()
      .then(() => {
        this.router.navigate(['verify-email-address']);
      });
  }*/

  updateConsentStatus(consentStatus: boolean | undefined): void {
    this.cookieConsentService.persistConsentStatus(consentStatus);
  }

  signUp(form: NgForm) {
      this.under_creating_account = true;
      this.recaptchaV3Service.execute('signup').subscribe((token) => {
        this.userSignUpInfo['recaptchaToken'] = token;
        this.appService
          .signUp(this.userSignUpInfo)
          .then((repsone) => {
            if (environment.apiUrl === "https://webapi.sarasanalytics.com/") {
              window['dataLayer'] = window['dataLayer'] || [];
              window["dataLayer"].push({
                event: "Sign-up",
                eventCategory: "Sign-Up",
                eventAction: "Success",
              });
              trackFreshsalesEvent("signup");

            }

            this.userSignInInfo.email = this.userSignUpInfo.email;
            this.userSignInInfo.password = this.userSignUpInfo.password;

            this.signIn(true);
          })
          .catch((e) => {
            this.under_creating_account = false;
          });
      }, (error) => {
        this.under_creating_account = false;
        console.error('reCAPTCHA error', error);
      });
  }

  clearData() {
    this.userSignInInfo = new UserSignInInfo();
    this.userSignUpInfo = new UserDetails();
    this.showForgotPassword = false;
  }

  forgotPassword() {
    this.showForgotPassword = true;

  }

  goBackToSignIn() {
    this.showForgotPassword = false;
  }

  freeTrialSubscribe() {
    let afterFreeTrial = (trialPlan)=>{
      this.signUpEvent(trialPlan);
      sessionStorage.setItem(NS_Enums.sessionStorageKeysEnum.isTrialSetupStepOneShown, JSON.stringify(true));
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title:  trialStarterHeading,
          content: trialStarterConfigureDestination,
          image: "successful",
          type: 'trialFlow',
          stepSection: [
            {
              text: 'Configure destination',
              status: 'current',
              colorCss: 'bg-blue'
            },
            {
              text: 'Configure source',
              status: 'next',
              colorCss: 'bg-gray-200'
            }
          ],
          buttons: [
            {
              title:  "Configure now",
              meta: "/connectors/datawarehouses-listing",
              type: "redirect",
              class: "confirm-dialog-later",
            },
          ],
        },
        disableClose: true,
      });
      // this.trialPlanUsed = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result?.type === 'redirect') {
          if(environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
            trackFreshsalesEvent("freeTrialStarted");
          }

          //this.router.navigate([result.meta]);
          this.router.navigate([
            "/" + this.baseWord + "/connectors/datawarehouses-listing",
          ]);
        }
      });
    }

    this.appService.getTrialPlan(this.userId).then((trialPlan) => {
      console.log("old activateTrialPlan bypassed", this.userSignInInfo.email);
      afterFreeTrial(trialPlan);
      // if(includes(this.userSignInInfo.email, "@sarasanalytics.com")){
      //   // when new internal users, we are not calling activateTrialPlan API
      //   console.log("old activateTrialPlan bypassed", this.userSignInInfo.email);
      //   afterFreeTrial(trialPlan);
      // } else {
      //   //TODO when external users are also allowed for new subscription feature then we should not call below activateTrialPlan API
      //   this.appService.activateTrialPlan(this.userId, trialPlan.plan).then((response) => {
      //     console.log("old activateTrialPlan called for external user", this.userSignInInfo.email);
      //     afterFreeTrial(trialPlan);
      //   });
      // }
    });
  }

  routeToTopics() {
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    if (saras_auth_key) {
      this.userId = saras_auth_key.userId;
      this.appService.getCurrentSubscriptionPlan(this.userId).then((response) => {
        const body = response.body;
        if (body.userSubscriptionId === 0) {
          this.disableComponents();
          const freeTrialQueryParam = this.route.snapshot.queryParamMap.get('free_trial');
          if (freeTrialQueryParam === '1') {
            this.routeToPricing(true);
          } else {
            this.appService.getEnabledWarehouseList(this.userId).then((warehouses) => {

              if(warehouses.find(warehouse => warehouse.status === 'ENABLED') !== undefined) {
                this.router.navigate(['/']);
              }else{

                this.appService.getCurrentSubscriptionPlan(this.userId).then((data: any) => {
                 // console.log(data)
                  if(data.body.planId === '') {
                    this.freeTrialSubscribe()
                  }/*else if(data.body.planId === 'trial') {
                    this.snackBar.open(
                      'Your account is on trial period', '',
                      {duration: 2500, verticalPosition: 'top',horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
                    this.router.navigate(['/' + this.baseWord + '/datawarehouses-listing']);
                  }*/
                })
              }
            })
          }
        } else {
          this.router.navigate(['/' + this.baseWord + '/integrations-list']);

          // this.appService.getTrialPlan(this.userId).then(trialPlan => {
          //   if (body.subscriptionPlanId === trialPlan.plan.subscriptionPlanId && trialPlan.expireIn === 0) {
          //     this.routeToPricing();
          //   } else {
          //     this.router.navigate(['/' + this.baseWord + '/integrations-list']);
          //   }
          // });

          // this.appService.getSourceCount(this.userId).then((count) => {
          //   if (count > 0) {
          //     this.routeToDashboard();
          //   } else {
          //     this.routeToIntegrations();
          //   }
          // });
        }
      });
    }
  }
  onKey(data){
            // console.log('data.target.value:',data.target.value);
             var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})|(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])|(((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]))|((?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.*[a-z])))(?=.{10,})");
             var mediumRegex = new RegExp("^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]))|((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]))|((?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*]))|(((?=.*[!@#\$%\^&\*])(?=.*[A-Z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[A-Z]))|((?=.*[0-9])(?=.*[a-z]))|((?=.*[!@#\$%\^&\*])(?=.*[a-z])))(?=.{6,})");
             var weakRegex = new RegExp("^((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[!@#\$%\^&\*]))|((?=.*[!@#\$%\^&\*])(?=.*[0-9]))|((?=.*[!@#\$%\^&\*])(?=.*[A-Z]))|((?=.*[a-z])|(?=.*[A-Z])|(?=.*[!@#\$%\^&\*])|(?=.*[0-9]))(?=.{4,})");

             var teststrong = strongRegex.test(data.target.value);
             var testmedium = mediumRegex.test(data.target.value);
             var testweak = weakRegex.test(data.target.value);


                     if(testweak!=true)
                     {
                          this.text_value="hide";
                     }
                    if(testweak==true && !(teststrong==true || testmedium==true))
                        {
                        this.weak_password=true;
                        this.medium_password=false;
                        console.log('this.weak_password:',this.weak_password);
                        this.text_value="Weak";
                        }

                    if(testmedium==true && !(teststrong==true))
                        {
                        this.medium_password=true;
                        this.strong_password=false;
                        console.log('this.medium_password:',this.medium_password);
                        this.text_value="Medium";
                        }

                    if(teststrong==true)
                        {
                         this.strong_password=true;
                         console.log('this.strong_password:',this.strong_password);

                         this.text_value="Strong";
                        }

      }
toggleFieldTextType_P() {
    this.fieldTextType_P = !this.fieldTextType_P;
  }
  toggleFieldTextType_CP() {
      this.fieldTextType_CP = !this.fieldTextType_CP;
    }
  disableComponents() {
    this.cacheService.putObject('disableDashboard', true, false);
    this.cacheService.putObject('disableDasource', true, false);
    this.cacheService.putObject('disableIntegrations', true, false);
    this.cacheService.putObject('disablePricing', false, false);

  }

  routeBackFromLogin() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/';
    }
    this.router.navigate([routeBack]);
  }

  routeToDashboard() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/' + this.baseWord + '/dashboard';
    }
    this.router.navigate([routeBack]);
  }

  routeToIntegrations() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/' + this.baseWord + '/integrations-list';
    }
    this.router.navigate([routeBack]);
  }

  routeToPricing(free_trial = false) {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      if (free_trial) {

        routeBack = oldPricingRoute;
        this.router.navigate([routeBack], {queryParams: {free_trial: '1'}});
      } else {
        routeBack = oldPricingRoute;
        this.router.navigate([routeBack]);
      }
    }
  }

  signUpEvent(trialPlan) {

    const today = Date.UTC(
      new Date().getFullYear(),
      new Date().getUTCMonth(),
      new Date().getDate()
    )
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate()+14);
    const trialEndFullDate = Date.UTC(
      currentDate.getFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getDate()
    )

    this.hubspotService.createSignupEvent(
      {
        properties: {
          user_id: this.userId,
          firstname: this.userSignUpInfo.firstName,
          lastname: this.userSignUpInfo.lastName,
          full_name: `${this.userSignUpInfo.firstName} ${this.userSignUpInfo.lastName}`,
          user_type: this.userRole,
          company: this.userSignUpInfo.company.name,
          email: this.userSignUpInfo.email,
          trial_created: today,
          trial_started: today,
          trial_ended: trialEndFullDate,
          current_subscription_plan: get(trialPlan, 'plan.planId', 'trial') //TODO New Subscription Check for any changes.
        }
      }
    );
  }

  private trackPageView(pageTitle) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      event: "virtual_pageview",
      page_location: get(window, 'location.href'),
      page_title: pageTitle || null,
    });
  }

  ngOnDestroy() {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

  }
}
